// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import * as XLSX from 'xlsx';
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import { useNavigate } from 'react-router-dom';
// import PdfPreview from '../../../../Common/PDFPreview';
// import { RingLoader } from 'react-spinners';
// import PrintButton from "../../../../Common/Buttons/PrintPDF";
// import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";
// import { Typography, Button } from '@mui/material';
// import {
//     Paper,
//     Table,
//     TableContainer,
//     TableHead,
//     TableBody,
//     TableRow,
//     TableCell
// } from '@mui/material';
// import SearchBar from "../../../../Common/UtilityCommon/SearchBar";
// import { fetchAccountBalance } from "../../../../Common/GetAccountBalance/GetAccountBalance";

// const apikey = process.env.REACT_APP_API;

// const PendingReports = () => {
//     const Company_Name = sessionStorage.getItem("Company_Name");
//     const Company_GSTNO = sessionStorage.getItem('Company_GSTNO');

//     const navigate = useNavigate();
//     const [reportData, setReportData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [pdfPreview, setPdfPreview] = useState(null);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [partyBalances, setPartyBalances] = useState({});

//     const API_URL = `${apikey}/partywise-stockReport`;

//     useEffect(() => {
//         setLoading(true);
//         axios.get(API_URL, {
//             params: {
//                 Company_Code: sessionStorage.getItem('Company_Code'),
//             }
//         }).then(response => {
//             setReportData(response.data);
//             setLoading(false);
//         }).catch(error => {
//             console.error('Error fetching report:', error);
//             setError('Failed to load data');
//             setLoading(false);
//         });
//     }, []);

//     useEffect(() => {
//         const run = async () => {
//             if (!reportData?.length) return;
//             const groups = groupReportData(reportData);

//             // collect unique buyer codes present in groups
//             const codes = Array.from(
//                 new Set(
//                     Object.values(groups)
//                         .map(g => g.buyerCode)
//                         .filter(Boolean)
//                 )
//             );

//             const entries = await Promise.all(
//                 codes.map(async (code) => {
//                     const { balance, gstNo } = await fetchAccountBalance(code);
//                     return [code, { balance, gstNo }];
//                 })
//             );

//             const map = {};
//             entries.forEach(([code, val]) => (map[code] = val));
//             setPartyBalances(map);
//         };

//         run();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [reportData]);


//     const groupReportData = (data) => {
//         const grouped = data.reduce((acc, item) => {
//             const bal = parseFloat(item.BALANCE || 0);
//             if (parseFloat(item.BALANCE) !== 0) {
//                 const { buyername } = item;
//                 const buyerCode =
//                     item.Buyer ?? item.Buyer_Party ?? item.buyer ?? item.buyer_code ?? null;
//                 if (!acc[buyername]) {
//                     acc[buyername] = {
//                         items: [],
//                         buyerCode,
//                         totalDespatch: 0,
//                         totalBalance: 0,
//                         totalQuantal: 0,
//                         totalStockValueAtSale: 0,
//                     };
//                 }
//                 acc[buyername].items.push(item);
//                 acc[buyername].totalDespatch += parseFloat(item.DESPATCH || 0);
//                 acc[buyername].totalBalance += parseFloat(item.BALANCE || 0);
//                 acc[buyername].totalQuantal += parseFloat(item.Buyer_Quantal || 0);
//                 const saleRate = parseFloat(item.Sale_Rate || 0);
//                 acc[buyername].totalStockValueAtSale += saleRate * bal;
//             }
//             return acc;
//         }, {});
//         return grouped;
//     };

//     const groupedReportData = groupReportData(reportData);

//     const calculateGrandTotals = () => {
//         const totals = {
//             totalQuantal: 0,
//             totalDespatch: 0,
//             totalBalance: 0,
//         };
//         Object.entries(groupedReportData).forEach(([_, group]) => {
//             totals.totalQuantal += group.totalQuantal;
//             totals.totalDespatch += group.totalDespatch;
//             totals.totalBalance += group.totalBalance;
//         });
//         return totals;
//     };

//     const handleExportToExcel = () => {
//         const wb = XLSX.utils.book_new();
//         const excelRows = [];
//         excelRows.push([
//             "Tender No", "Mill Name", "Grade", "M Rate", "S Rate", "Lifting", "Do", "Quantal", "Desp", "Bal"
//         ]);

//         Object.entries(groupedReportData).forEach(([buyername, group]) => {
//             excelRows.push([{ v: buyername, s: { font: { bold: true } }, t: 's' }]);
//             group.items.forEach(item => {
//                 excelRows.push([
//                     item.Tender_No,
//                     item.millshortname || '',
//                     item.Grade,
//                     item.Mill_Rate,
//                     item.Sale_Rate || '',
//                     item.Tender_Date || '0',
//                     item.Do || '',
//                     item.Buyer_Quantal || '0',
//                     item.DESPATCH || '0',
//                     item.BALANCE || '0'
//                 ]);
//             });

//             excelRows.push([
//                 "Total", "", "", "", "", "", "", group.totalQuantal.toFixed(2),
//                 group.totalDespatch.toFixed(2),
//                 group.totalBalance.toFixed(2)
//             ]);
//         });

//         const grandTotals = calculateGrandTotals();
//         excelRows.push([
//             "Grand Totals", "", "", "", "", "", "",
//             grandTotals.totalQuantal.toFixed(2),
//             grandTotals.totalDespatch.toFixed(2),
//             grandTotals.totalBalance.toFixed(2)
//         ]);

//         const ws = XLSX.utils.aoa_to_sheet(excelRows);
//         XLSX.utils.book_append_sheet(wb, ws, 'PartywiseBalaceStockReport');
//         XLSX.writeFile(wb, 'PartywiseBalaceStockReport.xlsx');
//     };

//     const generatePDF = () => {
//         const doc = new jsPDF('landscape', 'mm', 'a4');
//         const pageWidth = doc.internal.pageSize.getWidth();
//         doc.setFontSize(12);
//         doc.setTextColor(0, 0, 255);
//         const companyTextWidth = doc.getTextWidth(Company_Name);
//         doc.text(Company_Name, (pageWidth - companyTextWidth) / 2, 10);
//         doc.setFontSize(11);
//         doc.setTextColor(0, 0, 0);
//         const titleText = "Partywise Sugar Balance Stock";
//         doc.text(titleText, (pageWidth - doc.getTextWidth(titleText)) / 2, 18);
//         doc.setFontSize(10);
//         doc.text("Balance Stock", (pageWidth - doc.getTextWidth("Balance Stock")) / 2, 25);
//         let yOffset = 30;

//         Object.entries(groupedReportData).forEach(([buyername, group]) => {
//             doc.setFont("helvetica", "bold");
//             doc.setFillColor(230, 230, 230);
//             doc.rect(10, yOffset, 190, 8, "F");
//             doc.text(`Buyer: ${buyername}`, 12, yOffset + 5);
//             yOffset += 10;

//             const tableBody = group.items.map((item) => [
//                 item.Tender_No,
//                 item.millshortname || "",
//                 item.Grade,
//                 item.Mill_Rate,
//                 item.Sale_Rate || 0,
//                 item.Tender_Date || 0,
//                 item.Do || "",
//                 item.Buyer_Quantal || 0,
//                 item.DESPATCH || 0,
//                 item.BALANCE || 0
//             ]);

//             tableBody.push([
//                 "Total", "", "", "", "", "", "",
//                 group.totalQuantal.toFixed(2),
//                 group.totalDespatch.toFixed(2),
//                 group.totalBalance.toFixed(2),
//             ]);

//             doc.autoTable({
//                 startY: yOffset,
//                 head: [[
//                     "Tender No", "Mill Name", "Grade", "Mill Rate", "Sale Rate",
//                     "Lifting", "Do", "Quintal", "Desp", "Balance"
//                 ]],
//                 body: tableBody,
//                 theme: "grid",
//                 styles: { fontSize: 8, cellPadding: 2 },
//                 headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
//                 // alternateRowStyles: { fillColor: [240, 240, 240] },
//                 margin: { top: 10, left: 10, right: 10 },
//             });

//             yOffset = doc.lastAutoTable.finalY + 10;
//             if (yOffset > 270) {
//                 doc.addPage();
//                 yOffset = 10;
//             }
//         });

//         const grandTotals = calculateGrandTotals();
//         doc.setFontSize(10);
//         doc.text(
//             `Grand Totals: Quintal = ${grandTotals.totalQuantal.toFixed(2)}, Despatch = ${grandTotals.totalDespatch.toFixed(2)}, Balance = ${grandTotals.totalBalance.toFixed(2)}`,
//             10,
//             yOffset
//         );

//         const pdfBlob = doc.output("blob");
//         const pdfUrl = URL.createObjectURL(pdfBlob);
//         setPdfPreview(pdfUrl);
//     };

//     const toNum = (v) => {
//         const n = Number(v);
//         return Number.isFinite(n) ? n : 0;
//     };

//     return (
//         <div style={{ marginTop: "-90px" }}>
//             {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "18px", fontWeight: "bold" }}>{Company_Name}</Typography> */}
//             <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", fontWeight: "bold", color: "blue" }}>
//                 Partywise Sugar Balance Stock
//             </Typography>

//             <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "10px" }}>
//                 <div style={{ flex: 1, minWidth: "250px", maxWidth: "1100px" }}>
//                     <SearchBar value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//                 </div>

//                 <div className="d-flex flex-wrap align-items-center" style={{ gap: "8px" }}>
//                     {pdfPreview && <PdfPreview pdfData={pdfPreview} apiData={reportData} label={"Partywise Balance Stock Report"} />}
//                     <PrintButton disabledFeild={""} fetchData={generatePDF} />
//                     <Button variant="outlined" color="secondary" onClick={handleExportToExcel}>Export to Excel</Button>
//                     <Button variant="outlined" color="secondary" onClick={() => window.open('/millwise-stock', '_blank')}>
//                         Mill Wise Lifting Wise
//                     </Button>
//                     <Button variant="outlined" color="secondary" onClick={() => window.open('/self-stock', '_blank')}>
//                         Self Stock
//                     </Button>
//                 </div>
//             </div>

//             <div className="table-responsive">
//                 <Paper elevation={3} sx={{ marginBottom: 1 }}>
//                     <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
//                         <Table stickyHeader>
//                             <TableHead>
//                                 <TableRow sx={{
//                                     height: 30,
//                                     '& td, & th': {
//                                         padding: '4px 8px',
//                                     }
//                                 }}>
//                                     <TableCell align='center' style={{ color: "black", fontWeight: "bold" }}>Tender No</TableCell>
//                                     <TableCell style={{ color: "black", fontWeight: "bold" }}>Mill Name</TableCell>
//                                     <TableCell style={{ color: "black", fontWeight: "bold" }}>Grade</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>Mill Rate</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>Sale Rate</TableCell>
//                                     <TableCell style={{ color: "black", fontWeight: "bold" }}>Lifting Date</TableCell>
//                                     <TableCell style={{ color: "black", fontWeight: "bold" }}>Sauda Date</TableCell>
//                                     <TableCell style={{ color: "black", fontWeight: "bold" }}>Do</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>Quintal</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>Dispatch</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>Balance</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {Object.entries(groupedReportData)
//                                     .filter(([buyername, group]) =>
//                                         searchQuery.trim() === '' ||
//                                         buyername.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                                         group.items.some(item =>
//                                             Object.values(item).some(val =>
//                                                 val &&
//                                                 val.toString().toLowerCase().includes(searchQuery.toLowerCase())
//                                             )
//                                         )
//                                     )
//                                     .map(([buyername, group]) => (
//                                         <React.Fragment key={buyername}>
//                                             <TableRow >
//                                                 <TableCell colSpan={10} sx={{ color: 'blue', fontWeight: 'bold' }}>{buyername}</TableCell>
//                                             </TableRow>
//                                             {group.items.map((item, index) => (
//                                                 <TableRow key={index} hover sx={{
//                                                     height: 30,
//                                                     '& td, & th': {
//                                                         padding: '4px 8px',
//                                                     }
//                                                 }}>
//                                                     <TableCell>{item.Tender_No}</TableCell>
//                                                     <TableCell>{item.millshortname || ''}</TableCell>
//                                                     <TableCell>{item.Grade}</TableCell>
//                                                     <TableCell align='right'>{formatReadableAmount(item.Mill_Rate)}</TableCell>
//                                                     <TableCell align='right'>{formatReadableAmount(item.Sale_Rate)}</TableCell>
//                                                     <TableCell>{item.Tender_Date}</TableCell>
//                                                     <TableCell>{item.Sauda_Date}</TableCell>
//                                                     <TableCell>{item.Do}</TableCell>
//                                                     <TableCell align='right'>{formatReadableAmount(item.Buyer_Quantal)}</TableCell>
//                                                     <TableCell align='right'>{item.DESPATCH}</TableCell>
//                                                     <TableCell align='right'>{item.BALANCE}</TableCell>
//                                                 </TableRow>
//                                             ))}
//                                             <TableRow sx={{
//                                                 height: 30,
//                                                 '& td, & th': {
//                                                     padding: '4px 8px',
//                                                     backgroundColor: '#f3f388', fontWeight: 'bold'
//                                                 }
//                                             }} >
//                                                 <TableCell colSpan={5} align="left">
//                                                     {(() => {
//                                                         const buyerCode = group.buyerCode;
//                                                         const acct = buyerCode ? partyBalances[buyerCode] : null;
//                                                         const accountBalance = toNum(acct?.balance);
//                                                         const gstNo = acct?.gstNo ?? '';

//                                                         const stockValue = toNum(group.totalStockValueAtSale); // Σ(Sale_Rate * BALANCE)

//                                                         // If account balance is negative -> add stockValue; else subtract
//                                                         let pending = accountBalance < 0 ? (accountBalance + stockValue) : (accountBalance - stockValue);

//                                                         // tidy rounding and avoid -0
//                                                         pending = Number(pending.toFixed(2));
//                                                         if (Object.is(pending, -0)) pending = 0;
//                                                         return (
//                                                             <div style={{ display: "flex", gap: "20px" }}>
//                                                                 <span>
//                                                                     Party A/c Balance: {formatReadableAmount(accountBalance)}
//                                                                 </span>
//                                                                 <span>
//                                                                     Stock Value @ Sale Rate: {formatReadableAmount(stockValue)}
//                                                                 </span>
//                                                                 <span>
//                                                                     Pending Payment: {formatReadableAmount(pending)}
//                                                                 </span>
//                                                             </div>

//                                                         );
//                                                     })()}
//                                                 </TableCell>
//                                                 <TableCell colSpan={3} align='right'>Total</TableCell>
//                                                 <TableCell align='right'>{formatReadableAmount(group.totalQuantal.toFixed(2))}</TableCell>
//                                                 <TableCell align='right'>{formatReadableAmount(group.totalDespatch.toFixed(2))}</TableCell>
//                                                 <TableCell align='right'>{formatReadableAmount(group.totalBalance.toFixed(2))}</TableCell>
//                                             </TableRow>
//                                         </React.Fragment>
//                                     ))}
//                                 <TableRow sx={{
//                                     height: 30,
//                                     '& td, & th': {
//                                         padding: '4px 8px',
//                                         backgroundColor: '#f3f388', fontWeight: 'bold'
//                                     }
//                                 }}   >
//                                     <TableCell colSpan={8} style={{ color: "black", fontWeight: "bold" }}>Grand Totals</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>{formatReadableAmount(calculateGrandTotals().totalQuantal.toFixed(2))}</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>{formatReadableAmount(calculateGrandTotals().totalDespatch.toFixed(2))}</TableCell>
//                                     <TableCell align='right' style={{ color: "black", fontWeight: "bold" }}>{formatReadableAmount(calculateGrandTotals().totalBalance.toFixed(2))}</TableCell>
//                                 </TableRow>
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Paper>
//             </div>
//             {loading && (
//                 <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//                     <RingLoader />
//                 </div>
//             )}
//             {error && <p style={{ color: 'red' }}>{error}</p>}
//         </div>
//     );
// };

// export default PendingReports;
































import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import PdfPreview from '../../../../Common/PDFPreview';
import { ScaleLoader } from 'react-spinners';
import PrintButton from "../../../../Common/Buttons/PrintPDF";
import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";
import { Typography, Button } from '@mui/material';
import {
    Paper, Table, TableContainer, TableHead, TableBody,
    TableRow, TableCell, TableSortLabel, TableFooter
} from '@mui/material';
import SearchBar from "../../../../Common/UtilityCommon/SearchBar";
import { fetchAccountBalance } from "../../../../Common/GetAccountBalance/GetAccountBalance";
import CommonPrintView from '../../../../Common/ReportCommon/CommonPrintView';
import { generateReportPDF } from '../../../../Common/ReportCommon/CommonPDFGenerator';
import HeaderJK from '../../../../Assets/HeaderJK.png';
import FooterJK from '../../../../Assets/FooterJK.png';
import { ConvertNumberToWord } from '../../../../Common/FormatFunctions/ConvertNumberToWord';

const apikey = process.env.REACT_APP_API;

// ── Column definitions (screen + print) ──────────────────────────────────────
const SCREEN_COLUMNS = [
    { label: 'Tender No', key: 'Tender_No', width: '8%', numeric: false },
    { label: 'Mill Name', key: 'millshortname', width: '12%', numeric: false },
    { label: 'Grade', key: 'Grade', width: '6%', numeric: false },
    { label: 'Mill Rate', key: 'Mill_Rate', width: '8%', numeric: true },
    { label: 'Sale Rate', key: 'Sale_Rate', width: '8%', numeric: true },
    { label: 'Lifting Date', key: 'Tender_Date', width: '10%', numeric: false },
    { label: 'Sauda Date', key: 'Sauda_Date', width: '10%', numeric: false },
    { label: 'Do', key: 'Do', width: '8%', numeric: false },
    { label: 'Quintal', key: 'totalQuantal', width: '10%', numeric: true },
    { label: 'Dispatch', key: 'totalDespatch', width: '10%', numeric: true },
    { label: 'Balance', key: 'totalBalance', width: '10%', numeric: true },
];

const PRINT_COLUMNS = [
    { label: 'Tender No', key: 'Tender_No', printWidth: '22mm', numeric: false },
    { label: 'Mill Name', key: 'millshortname', printWidth: '30mm', numeric: false },
    { label: 'Grade', key: 'Grade', printWidth: '14mm', numeric: false },
    { label: 'Mill Rate', key: 'Mill_Rate', printWidth: '18mm', numeric: true },
    { label: 'Sale Rate', key: 'Sale_Rate', printWidth: '18mm', numeric: true },
    { label: 'Lifting Date', key: 'Tender_Date', printWidth: '22mm', numeric: false },
    { label: 'Sauda Date', key: 'Sauda_Date', printWidth: '22mm', numeric: false },
    { label: 'Do', key: 'Do', printWidth: '16mm', numeric: false },
    { label: 'Quintal', key: 'Buyer_Quantal', printWidth: '20mm', numeric: true },
    { label: 'Dispatch', key: 'DESPATCH', printWidth: '18mm', numeric: true },
    { label: 'Balance', key: 'BALANCE', printWidth: '18mm', numeric: true },
];

const PendingReports = () => {
    const Company_Name = sessionStorage.getItem("Company_Name");
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO');

    const navigate = useNavigate();
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [pdfPreview, setPdfPreview] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [partyBalances, setPartyBalances] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const requestSort = (key) => {
        setSortConfig(prev => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
        }));
    };

    const API_URL = `${apikey}/partywise-stockReport`;

    useEffect(() => {
        setLoading(true);
        axios.get(API_URL, {
            params: { Company_Code: sessionStorage.getItem('Company_Code') }
        })
            .then(response => { setReportData(response.data); setLoading(false); })
            .catch(err => { console.error(err); setError('Failed to load data'); setLoading(false); });
    }, []);

    useEffect(() => {
        const run = async () => {
            if (!reportData?.length) return;
            const groups = groupReportData(reportData);
            const codes = Array.from(new Set(Object.values(groups).map(g => g.buyerCode).filter(Boolean)));
            const entries = await Promise.all(
                codes.map(async code => {
                    const { balance, gstNo } = await fetchAccountBalance(code);
                    return [code, { balance, gstNo }];
                })
            );
            const map = {};
            entries.forEach(([code, val]) => (map[code] = val));
            setPartyBalances(map);
        };
        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportData]);

    // ── Grouping (unchanged logic) ───────────────────────────────────────────
    const groupReportData = (data) => {
        return data.reduce((acc, item) => {
            const bal = parseFloat(item.BALANCE || 0);
            if (parseFloat(item.BALANCE) !== 0) {
                const { buyername } = item;
                const buyerCode = item.Buyer ?? item.Buyer_Party ?? item.buyer ?? item.buyer_code ?? null;
                if (!acc[buyername]) {
                    acc[buyername] = {
                        items: [], buyerCode,
                        totalDespatch: 0, totalBalance: 0,
                        totalQuantal: 0, totalStockValueAtSale: 0,
                    };
                }
                acc[buyername].items.push(item);
                acc[buyername].totalDespatch += parseFloat(item.DESPATCH || 0);
                acc[buyername].totalBalance += parseFloat(item.BALANCE || 0);
                acc[buyername].totalQuantal += parseFloat(item.Buyer_Quantal || 0);
                acc[buyername].totalStockValueAtSale += parseFloat(item.Sale_Rate || 0) * bal;
            }
            return acc;
        }, {});
    };

    const groupedReportData = useMemo(() => groupReportData(reportData), [reportData]);

    // ── Sorted entries ───────────────────────────────────────────────────────
    const sortedEntries = useMemo(() => {
        const entries = Object.entries(groupedReportData);
        if (!sortConfig.key) return entries;
        return [...entries].sort(([, a], [, b]) => {
            let aVal, bVal;
            if (sortConfig.key === 'totalQuantal') { aVal = a.totalQuantal; bVal = b.totalQuantal; }
            else if (sortConfig.key === 'totalDespatch') { aVal = a.totalDespatch; bVal = b.totalDespatch; }
            else if (sortConfig.key === 'totalBalance') { aVal = a.totalBalance; bVal = b.totalBalance; }
            else { aVal = a.items[0]?.[sortConfig.key] ?? ''; bVal = b.items[0]?.[sortConfig.key] ?? ''; }
            if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });
    }, [groupedReportData, sortConfig]);

    // ── Grand totals ─────────────────────────────────────────────────────────
    const grandTotals = useMemo(() => {
        return Object.values(groupedReportData).reduce(
            (acc, g) => ({
                totalQuantal: acc.totalQuantal + g.totalQuantal,
                totalDespatch: acc.totalDespatch + g.totalDespatch,
                totalBalance: acc.totalBalance + g.totalBalance,
            }),
            { totalQuantal: 0, totalDespatch: 0, totalBalance: 0 }
        );
    }, [groupedReportData]);

    const toNum = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0; };

    // ── Flatten rows for PDF / print (group header + items + subtotal) ───────
    const flatRowsForPDF = useMemo(() => {
        const rows = [];
        sortedEntries.forEach(([buyername, group]) => {
            // Buyer header row (span-like — we pass a flag via a sentinel)
            rows.push({ __isBuyerHeader: true, buyername });
            group.items.forEach(item => {
                rows.push([
                    item.Tender_No ?? '',
                    item.millshortname ?? '',
                    item.Grade ?? '',
                    formatReadableAmount(item.Mill_Rate),
                    formatReadableAmount(item.Sale_Rate),
                    item.Tender_Date ?? '',
                    item.Sauda_Date ?? '',
                    item.Do ?? '',
                    formatReadableAmount(item.Buyer_Quantal),
                    formatReadableAmount(item.DESPATCH),
                    formatReadableAmount(item.BALANCE),
                ]);
            });
            // Sub-total row
            rows.push({
                __isSubTotal: true,
                values: [
                    'Sub Total', '', '', '', '', '', '', '',
                    formatReadableAmount(group.totalQuantal.toFixed(2)),
                    formatReadableAmount(group.totalDespatch.toFixed(2)),
                    formatReadableAmount(group.totalBalance.toFixed(2)),
                ],
            });
        });
        return rows;
    }, [sortedEntries]);

    // ── Excel export with proper right-alignment via cell styles ─────────────
    const handleExportToExcel = () => {
        // Numeric column indices (0-based): Mill Rate=3, Sale Rate=4, Quintal=7, Desp=8, Bal=9
        const numericCols = new Set([3, 4, 7, 8, 9]);

        const makeCell = (value, bold = false, isNumeric = false) => ({
            v: value,
            t: isNumeric ? 'n' : 's',
            s: {
                font: { bold },
                alignment: { horizontal: isNumeric ? 'right' : 'left' },
            },
        });

        const worksheetData = [];

        // Header rows
        worksheetData.push([makeCell(Company_Name.toUpperCase(), true)]);
        worksheetData.push([makeCell(`GST No: ${Company_GSTNO}`)]);
        worksheetData.push([makeCell('Partywise Sugar Balance Stock', true)]);
        worksheetData.push([]);

        // Column headers
        worksheetData.push(
            SCREEN_COLUMNS.map(c => makeCell(c.label, true, false))
        );

        // Data rows grouped
        Object.entries(groupedReportData).forEach(([buyername, group]) => {
            // Buyer name row
            worksheetData.push([makeCell(buyername, true)]);

            group.items.forEach(item => {
                worksheetData.push([
                    makeCell(item.Tender_No ?? '', false, false),
                    makeCell(item.millshortname ?? '', false, false),
                    makeCell(item.Grade ?? '', false, false),
                    makeCell(parseFloat(item.Mill_Rate) || 0, false, true),
                    makeCell(parseFloat(item.Sale_Rate) || 0, false, true),
                    makeCell(item.Tender_Date ?? '', false, false),
                    makeCell(item.Sauda_Date ?? '', false, false),
                    makeCell(item.Do ?? '', false, false),
                    makeCell(parseFloat(item.Buyer_Quantal) || 0, false, true),
                    makeCell(parseFloat(item.DESPATCH) || 0, false, true),
                    makeCell(parseFloat(item.BALANCE) || 0, false, true),
                ]);
            });

            // Sub-total row
            worksheetData.push([
                makeCell('Sub Total', true, false),
                makeCell('', false, false),
                makeCell('', false, false),
                makeCell('', false, false),
                makeCell('', false, false),
                makeCell('', false, false),
                makeCell('', false, false),
                makeCell('', false, false),
                makeCell(parseFloat(group.totalQuantal.toFixed(2)), true, true),
                makeCell(parseFloat(group.totalDespatch.toFixed(2)), true, true),
                makeCell(parseFloat(group.totalBalance.toFixed(2)), true, true),
            ]);
        });

        // Grand total row
        worksheetData.push([
            makeCell('Grand Total', true, false),
            makeCell('', false, false),
            makeCell('', false, false),
            makeCell('', false, false),
            makeCell('', false, false),
            makeCell('', false, false),
            makeCell('', false, false),
            makeCell('', false, false),
            makeCell(parseFloat(grandTotals.totalQuantal.toFixed(2)), true, true),
            makeCell(parseFloat(grandTotals.totalDespatch.toFixed(2)), true, true),
            makeCell(parseFloat(grandTotals.totalBalance.toFixed(2)), true, true),
        ]);

        // Column widths
        const colWidths = [12, 18, 8, 10, 10, 14, 14, 10, 12, 12, 12].map(w => ({ wch: w }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(worksheetData);
        ws['!cols'] = colWidths;
        XLSX.utils.book_append_sheet(wb, ws, 'PartywiseBalanceStock');
        XLSX.writeFile(wb, 'PartywiseBalanceStockReport.xlsx');
    };

    // ── PDF via generateReportPDF (same as SaleTDSRegister) ─────────────────
    const handleGeneratePDF = () => {
        // Flatten: buyer-header + items + subtotals → plain string arrays
        const rows = [];
        sortedEntries.forEach(([buyername, group]) => {
            // Buyer header as a "section" row — pass as a single-cell merged-style row
            rows.push([`► ${buyername}`, '', '', '', '', '', '', '', '', '', '']);
            group.items.forEach(item => {
                rows.push([
                    item.Tender_No ?? '',
                    item.millshortname ?? '',
                    item.Grade ?? '',
                    formatReadableAmount(item.Mill_Rate),
                    formatReadableAmount(item.Sale_Rate),
                    item.Tender_Date ?? '',
                    item.Sauda_Date ?? '',
                    item.Do ?? '',
                    formatReadableAmount(item.Buyer_Quantal),
                    formatReadableAmount(item.DESPATCH),
                    formatReadableAmount(item.BALANCE),
                ]);
            });
            rows.push([
                'Sub Total', '', '', '', '', '', '', '',
                formatReadableAmount(group.totalQuantal.toFixed(2)),
                formatReadableAmount(group.totalDespatch.toFixed(2)),
                formatReadableAmount(group.totalBalance.toFixed(2)),
            ]);
        });

        generateReportPDF({
            title: 'Partywise Sugar Balance Stock',
            subtitle: '',
            columns: PRINT_COLUMNS.map(c => c.label),
            columnWidths: [22, 25, 14, 18, 18, 16, 16, 12, 16, 16, 16],
            rows,
            footerRow: [
                'Grand Total', '', '', '', '', '', '', '',
                { content: formatReadableAmount(grandTotals.totalQuantal.toFixed(2)), styles: { halign: 'right' } },
                { content: formatReadableAmount(grandTotals.totalDespatch.toFixed(2)), styles: { halign: 'right' } },
                { content: formatReadableAmount(grandTotals.totalBalance.toFixed(2)), styles: { halign: 'right' } },
            ],
            numericCols: [3, 4, 8, 9, 10],
            amountInWords: ConvertNumberToWord(grandTotals.totalBalance),
            headerImgSrc: HeaderJK,
            footerImgSrc: FooterJK,
            onComplete: (url) => setPdfPreview(url),
        });
    };

    return (
        <div style={{ marginTop: "-90px" }}>
            {/* ── CommonPrintView (same pattern as SaleTDSRegister) ── */}
            <CommonPrintView
                title="Partywise Sugar Balance Stock"
                subtitle=""
                companyName={Company_Name}
                companyGST={Company_GSTNO}
                columns={PRINT_COLUMNS}
                rows={sortedEntries.flatMap(([buyername, group]) => [
                    { __buyerHeader: buyername },
                    ...group.items,
                    { __subTotal: group },
                ])}
                rowRenderer={(item) => {
                    if (item.__buyerHeader) return [`► ${item.__buyerHeader}`, '', '', '', '', '', '', '', '', '', ''];
                    if (item.__subTotal) {
                        const g = item.__subTotal;
                        return ['Sub Total', '', '', '', '', '', '', '',
                            formatReadableAmount(g.totalQuantal.toFixed(2)),
                            formatReadableAmount(g.totalDespatch.toFixed(2)),
                            formatReadableAmount(g.totalBalance.toFixed(2))];
                    }
                    return [
                        item.Tender_No ?? '', item.millshortname ?? '', item.Grade ?? '',
                        formatReadableAmount(item.Mill_Rate), formatReadableAmount(item.Sale_Rate),
                        item.Tender_Date ?? '', item.Sauda_Date ?? '', item.Do ?? '',
                        formatReadableAmount(item.Buyer_Quantal),
                        formatReadableAmount(item.DESPATCH),
                        formatReadableAmount(item.BALANCE),
                    ];
                }}
                footerValues={[
                    'Grand Total', '', '', '', '', '', '', '',
                    formatReadableAmount(grandTotals.totalQuantal.toFixed(2)),
                    formatReadableAmount(grandTotals.totalDespatch.toFixed(2)),
                    formatReadableAmount(grandTotals.totalBalance.toFixed(2)),
                ]}
                amountInWords={ConvertNumberToWord(grandTotals.totalBalance)}
                headerImg={HeaderJK}
                footerImg={FooterJK}
            />

            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", fontWeight: "bold", color: "blue" }}>
                Partywise Sugar Balance Stock
            </Typography>

            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "10px" }}>
                <div style={{ flex: 1, minWidth: "250px", maxWidth: "1100px" }}>
                    <SearchBar value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                </div>
                <div className="d-flex flex-wrap align-items-center" style={{ gap: "8px" }}>
                    {pdfPreview && (
                        <PdfPreview pdfData={pdfPreview} apiData={reportData} label="Partywise Balance Stock Report" />
                    )}
                    {/* Print PDF — same red button style as SaleTDSRegister */}
                    <button className="btn btn-danger me-2 no-print" onClick={handleGeneratePDF}>
                        Print
                    </button>
                    <Button variant="outlined" color="secondary" onClick={handleExportToExcel}>
                        Export to Excel
                    </Button>
                    <Button variant="outlined" color="secondary" onClick={() => window.open('/millwise-stock', '_blank')}>
                        Mill Wise Lifting Wise
                    </Button>
                    <Button variant="outlined" color="secondary" onClick={() => window.open('/self-stock', '_blank')}>
                        Self Stock
                    </Button>
                </div>
            </div>

            <div className="table-responsive">
                <Paper elevation={3} sx={{ marginBottom: 1 }}>
                    <TableContainer sx={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    {SCREEN_COLUMNS.map(col => (
                                        <TableCell
                                            key={col.key}
                                            align={col.numeric ? 'right' : 'left'}
                                            style={{
                                                backgroundColor: '#5557df',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                width: col.width,
                                                padding: '8px',
                                            }}
                                        >
                                            <TableSortLabel
                                                active={sortConfig.key === col.key}
                                                direction={sortConfig.key === col.key ? sortConfig.direction : 'asc'}
                                                onClick={() => requestSort(col.key)}
                                                sx={{
                                                    '&.MuiTableSortLabel-root': { color: '#fff' },
                                                    '&.MuiTableSortLabel-root:hover': { color: '#cce0ff' },
                                                    '&.Mui-active': { color: '#fff' },
                                                    '& .MuiTableSortLabel-icon': { color: '#fff !important' },
                                                }}
                                            >
                                                {col.label}
                                            </TableSortLabel>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {sortedEntries
                                    .filter(([buyername, group]) =>
                                        searchQuery.trim() === '' ||
                                        buyername.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                        group.items.some(item =>
                                            Object.values(item).some(val =>
                                                val && val.toString().toLowerCase().includes(searchQuery.toLowerCase())
                                            )
                                        )
                                    )
                                    .map(([buyername, group]) => (
                                        <React.Fragment key={buyername}>
                                            {/* Buyer name header row */}
                                            <TableRow>
                                                <TableCell
                                                    colSpan={11}
                                                    sx={{ color: 'blue', fontWeight: 'bold', padding: '4px 8px' }}
                                                >
                                                    {buyername}
                                                </TableCell>
                                            </TableRow>

                                            {/* Item rows */}
                                            {group.items.map((item, index) => (
                                                <TableRow
                                                    key={index}
                                                    hover
                                                    style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f5f8ff' }}
                                                    sx={{ height: 30, '& td, & th': { padding: '4px 8px' } }}
                                                >
                                                    <TableCell>{item.Tender_No}</TableCell>
                                                    <TableCell>{item.millshortname || ''}</TableCell>
                                                    <TableCell>{item.Grade}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(item.Mill_Rate)}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(item.Sale_Rate)}</TableCell>
                                                    <TableCell>{item.Tender_Date}</TableCell>
                                                    <TableCell>{item.Sauda_Date}</TableCell>
                                                    <TableCell>{item.Do}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(item.Buyer_Quantal)}</TableCell>
                                                    <TableCell align="right">{item.DESPATCH}</TableCell>
                                                    <TableCell align="right">{item.BALANCE}</TableCell>
                                                </TableRow>
                                            ))}

                                            {/* Sub-total row with party balances */}
                                            <TableRow sx={{
                                                height: 30,
                                                '& td, & th': {
                                                    padding: '4px 8px',
                                                    backgroundColor: '#f3f388',
                                                    fontWeight: 'bold',
                                                }
                                            }}>
                                                <TableCell colSpan={5} align="left">
                                                    {(() => {
                                                        const acct = group.buyerCode ? partyBalances[group.buyerCode] : null;
                                                        const accountBalance = toNum(acct?.balance);
                                                        const stockValue = toNum(group.totalStockValueAtSale);
                                                        let pending = accountBalance < 0
                                                            ? accountBalance + stockValue
                                                            : accountBalance - stockValue;
                                                        pending = Number(pending.toFixed(2));
                                                        if (Object.is(pending, -0)) pending = 0;
                                                        return (
                                                            <div style={{ display: 'flex', gap: '20px' }}>
                                                                <span>Party A/c Balance: {formatReadableAmount(accountBalance)}</span>
                                                                <span>Stock Value @ Sale Rate: {formatReadableAmount(stockValue)}</span>
                                                                <span>Pending Payment: {formatReadableAmount(pending)}</span>
                                                            </div>
                                                        );
                                                    })()}
                                                </TableCell>
                                                <TableCell colSpan={3} align="right">Total</TableCell>
                                                <TableCell align="right">{formatReadableAmount(group.totalQuantal.toFixed(2))}</TableCell>
                                                <TableCell align="right">{formatReadableAmount(group.totalDespatch.toFixed(2))}</TableCell>
                                                <TableCell align="right">{formatReadableAmount(group.totalBalance.toFixed(2))}</TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                            </TableBody>

                            {/* Sticky grand total footer — same as SaleTDSRegister */}
                            <TableFooter style={{ position: 'sticky', bottom: 0, zIndex: 2 }}>
                                <TableRow style={{ backgroundColor: '#ffffcc' }}>
                                    <TableCell colSpan={8} style={{ fontWeight: 'bold', color: 'black' }}>
                                        GRAND TOTAL
                                    </TableCell>
                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>
                                        {formatReadableAmount(grandTotals.totalQuantal.toFixed(2))}
                                    </TableCell>
                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>
                                        {formatReadableAmount(grandTotals.totalDespatch.toFixed(2))}
                                    </TableCell>
                                    <TableCell align="right" style={{ fontWeight: 'bold' }}>
                                        {formatReadableAmount(grandTotals.totalBalance.toFixed(2))}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Paper>
            </div>

            {/* ScaleLoader — same as SaleTDSRegister */}
            {loading && (
                <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
                    <ScaleLoader color="#36d7b7" height={35} width={4} radius={2} margin={2} />
                </div>
            )}

            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default PendingReports;